<template>
  <div class="col-12 pr-0">
    <div>
      <section-title
        class="mt-3"
        content="Firmas del Participante"
        :has-line="true"
      />
      <div v-if="hasParticipants" class="py-2">
        <div
          v-for="(row, index) of participants"
          :key="`signaturesprovider-item-${index}`"
          class="result-table pt-2"
        >
          <div class="row pt-2 col-12 align-items-center">
            <div class="col-md-1 text-left">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio-button
                  :ref="`primary-signer-${index}`"
                  v-model="row.isPrimary"
                  custom-error-msg="Firmante es requerido."
                  :error="errors[0]"
                  :is-disabled="false"
                  is-inline
                  :options="[
                    {
                      value: row.isPrimary ? true : index,
                    },
                  ]"
                  @input="changePrimarySignerHandler(row)"
                />
              </validation-provider>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Nombre del Firmante:</div>
              <div class="color-black font-16 bold">
                {{ row.participantFullName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Parentesco:</div>
              <div class="color-black font-16 bold">
                {{ row.relationTypeDescription | empty }}
              </div>
            </div>
            <div class="col-md-4">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }}
                {{ row.userName ? `/ ${row.userName}` : '' }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Número de Teléfono:</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="margin-bottom: -15px;">
          <row-message
            class="row-message"
            text="No se encontraron usuarios del portal de padres relacionados a este estudiante. 
                  Para poder firmar de manera electrónica el contratante debe tener acceso al portal. 
                  El contratante se puede registrar en la plataforma a través del siguiente enlace 
                  https://mipe-padres.dde.pr"
            warning
          />
        </div>
        <custom-result-not-found :text="'No hay información disponible.'" />
      </div>
    </div>
  </div>
</template>

<script>
//components
import SectionTitle from 'SectionTitle';
import CustomRadioButton from 'custom-radio';
import CustomResultNotFound from 'custom-result-not-found';
import RowMessage from '@/components/common/RowMessage.vue';
import { ValidationProvider } from 'vee-validate';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//services
import { getSignatureParticipants as _getSignatureParticipants } from '@/services/uspqrp/intervention-plan.api.js';

export default {
  name: 'SignatureElectronic',
  components: {
    SectionTitle,
    CustomRadioButton,
    CustomResultNotFound,
    RowMessage,
    ValidationProvider,
  },
  mixins: [alertMixin],
  async mounted() {
    await this.getParticipants();
  },
  props: {
    interventionPlanId: {
      type: Number,
      default: null,
      required: false,
    },
    documentTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    studentSieId: {
      type: Number,
      default: null,
      required: false,
    },
    signatureParticipants: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  computed: {
    hasParticipants() {
      return this.participants?.length || 0 > 0;
    },
    participants: {
      get() {
        return this.signatureParticipants;
      },
      set(value) {
        this.$emit('update:signatureParticipants', value);
      },
    },
  },
  methods: {
    async getParticipants() {
      const params = {
        isElectronicSignature: true,
        studentSieId: this.studentSieId,
        planId: this.interventionPlanId,
        documentTypeId: this.documentTypeId,
      };
      this.participants = (await _getSignatureParticipants(params)).data || [];
    },
    changePrimarySignerHandler(row) {
      this.participants = this.participants.map((participant) => {
        return {
          ...participant,
          isPrimary: participant.id === row.id,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
  padding-bottom: 20px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
.button-table {
  justify-content: flex-end !important;
  float: right !important;
}
.mr-0 {
  padding-left: 16px !important;
}
.btn-action-size {
  width: auto !important;
}
.btn-action-size-cancel {
  width: 40px;
  height: 40px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}

::v-deep input[type='checkbox'] + label span {
  background-color: white;
}
</style>
